import type {IRegister} from "../types/IRegister";

export const registerFormDefaultValues: IRegister = {
    email: "",
    password: "",
    marketing_email: false,
    marketing_sms: false,
    phone: {
        code: 48,
        number: ""
    }
};
import type {IRegister} from "../types/IRegister";

export const registerFormDefaultValues: IRegister = {
    email: "",
    password: "",
    marketing_email: false,
    marketing_sms: false,
    phone: {
        code: 48,
        number: ""
    }
};
